import { OnboardingFormFields, USA_STATES_LIST } from '@Types/index';
import { t } from 'i18next';
import { ControlledDropdown } from '../ControlledInputs';

interface IProps {
  disabled: boolean;
  tabIndex: number;
}
export const AddressStateInput = ({ disabled, tabIndex }: IProps) => {
  return (
    <ControlledDropdown
      title={t('pages.homeAddress.stateFieldTitle')}
      items={USA_STATES_LIST}
      id={OnboardingFormFields.STATE}
      disabled={disabled}
      tabIndex={tabIndex}
      name={OnboardingFormFields.STATE}
    />
  );
};
